<ng-container *ngIf="data">
    
    <div *ngIf="data.description" [innerHTML]="data.description.value"></div>

    <app-panels *ngIf="data.panels && data.panels.value" [items]="data.panels.value"></app-panels>
</ng-container>
